import { makeCygnusApiCall } from "../../../../../api/api";
import { COIRegistryBulkUploadResult } from "./COIRegistryUploadModal.types";

export const uploadCOIRegistryBulk = async (
  file: File
): Promise<COIRegistryBulkUploadResult | null> => {
  const formData = new FormData();
  formData.append("SpreadsheetFile", file);

  const response = await makeCygnusApiCall({
    type: "POST",
    url: "/firm_setup/coi_registry_bulk_upload",
    payload: formData,
    payload_is_file: true,
    forMDM: true,
    show_message: false,
  });

  if (!response?.success) {
    throw new Error(response?.message || "Failed to upload spreadsheet.");
  }

  return response?.data ?? null;
};
